(function () {
  const GRID_SELECTOR = '#facets-results > ul.grid';
  const PROMO_ITEM_CLASS = 'collection-promo-card-item';

  function getGridColumnCount(grid) {
    const columns = getComputedStyle(grid)
      .gridTemplateColumns.split(' ')
      .filter((track) => track && track !== '0px');
    return Math.max(1, columns.length);
  }

  /** Group grid items by row using column count (reliable on mobile CSS grid). */
  function groupGridRows(grid) {
    const cols = getGridColumnCount(grid);
    const items = Array.from(grid.children);
    const rows = [];

    for (let i = 0; i < items.length; i += cols) {
      rows.push({ items: items.slice(i, i + cols) });
    }

    return rows;
  }

  function measureProductItemHeight(item) {
    const tile = item.querySelector('.product-tile');
    const target = tile || item;
    return target.getBoundingClientRect().height;
  }

  function tallestProductRowHeight(rowItems) {
    let maxHeight = 0;

    for (const item of rowItems) {
      if (item.classList.contains(PROMO_ITEM_CLASS)) continue;
      maxHeight = Math.max(maxHeight, measureProductItemHeight(item));
    }

    return maxHeight;
  }

  function resetPromoHeights(promoItems) {
    for (const item of promoItems) {
      item.style.minHeight = '';
      item.querySelector('.collection-promo-card')?.style.removeProperty('min-height');
    }
  }

  function tallestProductOnPage(grid) {
    let maxHeight = 0;

    for (const item of grid.children) {
      if (item.classList.contains(PROMO_ITEM_CLASS)) continue;
      maxHeight = Math.max(maxHeight, measureProductItemHeight(item));
    }

    return maxHeight;
  }

  function syncPromoHeightsInSection(section) {
    const grid = section.querySelector(GRID_SELECTOR);
    if (!grid) return;

    const promoItems = grid.querySelectorAll('.' + PROMO_ITEM_CLASS);
    if (!promoItems.length) return;

    resetPromoHeights(promoItems);

    const pageMaxProductHeight = tallestProductOnPage(grid);

    for (const row of groupGridRows(grid)) {
      let targetHeight = tallestProductRowHeight(row.items);
      if (targetHeight <= 0) {
        targetHeight = pageMaxProductHeight;
      }
      if (targetHeight <= 0) continue;

      const heightPx = Math.ceil(targetHeight) + 'px';
      for (const item of row.items) {
        if (!item.classList.contains(PROMO_ITEM_CLASS)) continue;

        item.style.minHeight = heightPx;
        const card = item.querySelector('.collection-promo-card');
        if (card) {
          card.style.minHeight = heightPx;
        }
      }
    }
  }

  function observeProductTiles(section, grid, scheduleSync) {
    if (typeof ResizeObserver === 'undefined') return;

    if (grid._collectionPromoTileObserver) {
      grid._collectionPromoTileObserver.disconnect();
    }

    const observer = new ResizeObserver(scheduleSync);
    grid._collectionPromoTileObserver = observer;

    observer.observe(grid);
    grid.querySelectorAll(':scope > li:not(.' + PROMO_ITEM_CLASS + ')').forEach((item) => {
      observer.observe(item);
      const tile = item.querySelector('.product-tile');
      if (tile) observer.observe(tile);
    });
  }

  function bindImageLoadSync(grid, scheduleSync) {
    grid.querySelectorAll('img').forEach((img) => {
      if (!img.complete) {
        img.addEventListener('load', scheduleSync, { once: true });
      }
    });
  }

  function initSection(section) {
    const grid = section.querySelector(GRID_SELECTOR);
    if (!grid || !grid.querySelector('.' + PROMO_ITEM_CLASS)) return;

    if (grid._collectionPromoSyncInit) return;
    grid._collectionPromoSyncInit = true;

    const scheduleSync = () => {
      cancelAnimationFrame(grid._collectionPromoSyncRaf);
      grid._collectionPromoSyncRaf = requestAnimationFrame(() => {
        syncPromoHeightsInSection(section);
      });
    };

    scheduleSync();
    observeProductTiles(section, grid, scheduleSync);
    bindImageLoadSync(grid, scheduleSync);

    if (!grid._collectionPromoMutationObserver) {
      const results = section.querySelector('#facets-results');
      if (results && typeof MutationObserver !== 'undefined') {
        const mo = new MutationObserver(scheduleSync);
        mo.observe(results, { childList: true, subtree: true });
        grid._collectionPromoMutationObserver = mo;
      }
    }
  }

  function initAll() {
    document.querySelectorAll('.shopify-section').forEach(initSection);
  }

  function syncAll() {
    document.querySelectorAll('.shopify-section').forEach(syncPromoHeightsInSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.addEventListener('load', syncAll);

  document.addEventListener('shapes:section:hasmutated', (event) => {
    const section = event.target.closest('.shopify-section');
    if (!section?.querySelector('#facets-results .' + PROMO_ITEM_CLASS)) return;

    const grid = section.querySelector(GRID_SELECTOR);
    if (grid) {
      grid._collectionPromoSyncInit = false;
      if (grid._collectionPromoTileObserver) {
        grid._collectionPromoTileObserver.disconnect();
        grid._collectionPromoTileObserver = null;
      }
    }

    initSection(section);
  });

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(syncAll, 150);
  });
})();
